import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';


const LayoutRoutes = () => {

  return (
    <>
      <Routes>
 
        {routes.map(({ path, Component }, i) => (
          <Route element={<AppLayout />} key={i}>     
          {/* <Route path={`${process.env.PUBLIC_URL}/systemsettings`} element={<SystemSettings  />}>
          <Route index element={<Navigate to={`${process.env.PUBLIC_URL}/systemsettings/currencies`} />} />
              
              <Route  path="currencies" element={<Currency />} />
              <Route path="countries" element={<Countries />} />
              <Route path="cities" element={<Cites />} />
              <Route path="nationalities" element={<Nationalities />} />
              <Route path="companies" element={<Companies />} />
              <Route path="company-fields" element={<Company />} />
              <Route path='pages' element={<Pages/>}/>
              <Route path="rules" element={<Rules />} />
              <Route path='articles' element={<Articles/>}/>
              <Route path='categories' element={<Categories/>}/>
            </Route> */}


        
             
            
            
            <Route path={path} element={Component} />
          </Route>
        ))}
      </Routes>
    </>
  );
};

export default LayoutRoutes;